// The video series records half-minutes, so a minute's active TV is half the
// stored value. Kept in one place because three different screens read the same
// array and a divisor that drifts would put different numbers for the same
// programme in front of the same person.
export const ACTIVE_TV_DIVISOR = 2;

// Averaged, never summed: active TV counts sets at a moment, so adding the
// minutes of a programme together answers a question nobody asked.
export function averageActiveTv(minutes) {
  if (!Array.isArray(minutes) || minutes.length === 0) return 0;

  let total = 0;
  for (let i = 0; i < minutes.length; i++) {
    total += Number(minutes[i]) || 0;
  }
  return Math.round(total / ACTIVE_TV_DIVISOR / minutes.length);
}
